import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";

const Contact = () => {
    return (
      <section id="contact" className="bg-[#1A2A3A] text-white py-8">
        <footer className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Information */}
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold mb-4">Cotton Kosovo Socks</h3>
              <p className="text-sm mb-2">&copy; 2024 Cotton Kosovo Socks</p>
              <p className="text-sm mb-4">All rights reserved</p>
              <p className="text-sm">Comfortable and stylish socks for every occasion.</p>
            </div>
  
            {/* Quick Links */}
            <div className="text-center">
              <h3 className="text-xl font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="/about" className="hover:underline">About Us</a></li>
                <li><a href="/products" className="hover:underline">All Products</a></li>
              </ul>
            </div>
  
            {/* Contact and Social Media */}
            <div className="text-center md:text-right">
              <h3 className="text-xl font-bold mb-4">Contact Us</h3>
              <p className="text-sm mb-2">Email: cottonsockskosovo@gmail.com</p>
              <p className="text-sm mb-4">Address: Agim Ramadani, Pristina, Kosovo</p>
              <div className="flex justify-center md:justify-end space-x-4">
                <a href="https://www.instagram.com/cotton.socks.ks/?hl=en" className="text-[#c13584] hover:text-[#e1306c] transition duration-300">
                    <FaInstagram className='h-7 w-7'/>
                </a>
                 <a href="https://www.facebook.com/Cotton.socks.ks" className="text-[#3b5998] hover:text-[#1877f2] transition duration-300">
                    <FaFacebookF className='h-7 w-7'/>
                </a>
              </div>
            </div>
          </div>
        </footer>
      </section>
    );
  };
  
  export default Contact;